import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import ReactMarkdown from 'react-markdown';
import { Sparkles, Loader2, RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';
import { Section, dateFr } from './shared';

export const AideIA = ({ num, aide, onAide }) => {
  const [busy, setBusy] = useState(false);
  const demander = async () => {
    setBusy(true);
    try {
      onAide((await axios.post(`/qualiopi/indicateurs/${num}/aide-ia`, {}, { timeout: 120000 })).data);
    } catch (e) { toast.error(e.response?.data?.detail || "L'assistant IA ne répond pas, réessayez"); } finally { setBusy(false); }
  };
  return (
    <Section titre="Aide IA" icone={Sparkles} testId="qualiopi-aide-ia">
      {aide?.texte && (
        <div className="rounded-xl border border-violet-100 bg-gradient-to-br from-violet-50/60 to-white p-4" data-testid="qualiopi-aide-ia-texte">
          <div className="prose prose-sm max-w-none prose-headings:text-[#0F172A] prose-strong:text-[#0F172A] prose-li:my-0.5">
            <ReactMarkdown>{aide.texte}</ReactMarkdown>
          </div>
          <p className="mt-2 text-xs text-slate-400">Suggestion générée le {dateFr(aide.date)}</p>
        </div>
      )}
      <Button variant="outline" onClick={demander} disabled={busy} className="w-full border-violet-200 text-violet-700 hover:bg-violet-50" data-testid="qualiopi-aide-ia-btn">
        {busy ? <><Loader2 className="h-4 w-4 animate-spin mr-2" /> Analyse en cours (≈ 20 s)…</>
          : aide?.texte ? <><RefreshCw className="h-4 w-4 mr-2" /> Relancer l'aide IA</>
            : <><Sparkles className="h-4 w-4 mr-2" /> Quelles preuves réunir ? (Aide IA)</>}
      </Button>
    </Section>
  );
};
